import { createSlice } from '@reduxjs/toolkit';
import { ITypeOfPayment } from '../../../../dto';
import { setTypeOfPayment } from '../actions';
import { MN_TYPE_OF_PAYMENTS, TYPE_ELEMENT } from '../../../../common';

export interface TypeOfPaymentState {
  data: ITypeOfPayment | null;
  loading: boolean;
  error: string | null;
}

const initialState: TypeOfPaymentState = {
  data: null,
  loading: false,
  error: null,
};

export const typeOfPaymentSlice = createSlice({
  name: `${MN_TYPE_OF_PAYMENTS}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setTypeOfPayment, (state, { payload }) => {
      state.data = payload;
    });
  },
});
